export class Magazine{
    id
    name
}



// WEBPACK FOOTER //
// ./src/Models/Magazine.js